import styled from '@emotion/styled'

export const StyleImageGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;

  /* Tablet */
  @media (max-width: 1024px) {
    grid-template-columns: repeat(3, 1fr);
  }

  /* Mobile */
  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }

  /* Small mobile */
  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`

export const StyleImage = styled.img`
  width: 100%;
  height: 100%;
  max-height: 230px;
  border-radius: 22px;
  object-fit: contain;
`
